import React from 'react';
import { Card, CardContent } from '@mui/material';
import { motion } from 'framer-motion';
import FilterBar from './FilterBar';
import { glassCardSx } from './SaaSTokens';

const MotionCard = motion(Card);

/**
 * Filter bar shell used on list pages (matches UserList): glass card + pill search/filters.
 */
const ListFilterBar = (props) => (
  <MotionCard
    initial={{ opacity: 0, y: 14 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.3, delay: 0.16 }}
    elevation={0}
    sx={{ ...glassCardSx, mb: 2.5 }}
  >
    <CardContent sx={{ p: { xs: 1.5, sm: 2.5 }, position: 'relative', zIndex: 1 }}>
      <FilterBar {...props} />
    </CardContent>
  </MotionCard>
);

export default ListFilterBar;
